import { createFileRoute } from '@tanstack/react-router';
import { AssistantPage } from '@/features/assistant/AssistantPage';
import { isMarket, type Market } from '@/lib/market/types';

export const Route = createFileRoute('/$market/assistant')({
  component: MarketAssistantRoute,
});

function MarketAssistantRoute() {
  const { market: rawMarket } = Route.useParams();
  const market: Market = isMarket(rawMarket) ? rawMarket : 'tw';

  return <AssistantPage market={market} />;
}
